module.exports = __webpack_public_path__ + "img/volta_logo.e52ac09e.svg";